import { Component } from '@angular/core';
import { DwComponentSectionConfigPreference, DwMdSectionConfigBaseComponent } from '@devwareapps/devware-cap';
import { CheckrideStatusAudience, CheckrideStatusConfig } from '../../models/checkride-status-config.model';

@Component({
  selector: 'app-checkride-status-config',
  template: `
    <div *ngIf="section?.config">
      <div dwRow>
        <div dwCol="12">
          <label>Audience</label>
          <select class="form-control" [(ngModel)]="section.config.audience" (ngModelChange)="onAudienceChange($event)">
            <option value="student">Student</option>
            <option value="examiner">Examiner</option>
            <option value="school">School</option>
          </select>
        </div>
      </div>
    </div>
  `
})
export class CheckrideStatusConfigComponent extends DwMdSectionConfigBaseComponent<DwComponentSectionConfigPreference<CheckrideStatusConfig>> {
  setupComplete(): void {
    this.section.config = {
      audience: 'student',
      ...(this.section.config || {})
    };
  }

  onAudienceChange(audience: CheckrideStatusAudience): void {
    this.onSectionChange();
  }
}
